import { useTranslation, Trans } from "react-i18next";
import { formatAmountString } from "../../utils/format";

export function EventMessage({ event }) {
  const { t } = useTranslation();
  const fullName = `${event.user.firstName} ${event.user.lastName}`;
  const eventKey = `event.${event.event}`;

  const Highlight = ({ children }) => (
    <span className="text-[#043F88] font-bold">{children}</span>
  );

  const ReasonHighlight = ({ children }) => (
    <span className="text-[#043F88] font-bold italic">{children}</span>
  );

  const eventConfig = {
    CREATED: {
      values: { user: fullName },
      components: { user: <Highlight /> }
    },
    UPDATED_FIELD: {
      values: {
        user: fullName,
        field: event.eventDetail,
        old: event.eventOldValue,
        new: event.eventNewValue
      },
      components: {
        user: <Highlight />,
        field: <Highlight />,
        old: <Highlight />,
        new: <Highlight />
      }
    },
    UNPAID: {
      values: { user: fullName },
      components: { user: <Highlight /> }
    },
    TREATED: {
      values: { user: fullName },
      components: { user: <Highlight /> }
    },
    UNDO_UNPAID: {
      values: {
        user: fullName,
        reason: event.eventDetail?.toLowerCase() || ""
      },
      components: {
        user: <Highlight />,
        reason: <ReasonHighlight />
      }
    },
    ATTACH: {
      values: {
        user: fullName,
        amount: formatAmountString(event.eventNewValue),
        detail: event.eventDetail
      },
      components: {
        user: <Highlight />,
        amount: <Highlight />,
        detail: <Highlight />
      }
    },
    DETACH: {
      values: {
        user: fullName,
        amount: formatAmountString(event.eventNewValue),
        detail: event.eventDetail
      },
      components: {
        user: <Highlight />,
        amount: <Highlight />,
        detail: <Highlight />
      }
    }
  };

  const config = eventConfig[event.event];

  return (

      <p className="text-[#1D1C40] font-medium text-[16px] leading-tight">
        {config ? (
          <Trans
            i18nKey={eventKey}
            values={config.values}
            components={config.components}
          />
        ) : (
          t("Unknown event")
        )}
      </p>
  );
}

